import * as React from "react";
import { App } from "./app"

interface NobbAlphaButtonVm {
    buttonID: string
    tooltipText: string
    app: App
}

interface ButtonState {
    hoverState: string
}

// Displays a button that let you switch between aplhabetical or nobb tree showing of nobb groups
export class NobbAlphaButton extends React.Component<NobbAlphaButtonVm, ButtonState> {
    constructor(props: NobbAlphaButtonVm) {
        super(props)
    }

    state: ButtonState = {
        hoverState: "out"
    }

    // Passes on clicks to a handler within Core:
    onClick() {
        this.props.app.GetCore().HandleButton(this.props.buttonID)
    }

    // Handler for mouse out changes the state of the button, which only affects the graphics
    mouseOutHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "out" })
    }

    // Handler for mouse over changes the state of the button, which only affects the graphics
    mouseOverHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "hover" })
    }

    // Handler for mouse down changes the state of the button, which only affects the graphics
    mouseDownHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "pressed" })
    }

    // Handler for mouse up changes the state of the button, which only affects the graphics
    mouseUpHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "hover" })
    }

    render() {
        const bgFile = "url(images/nobbAlphaButton.png)"
        const buttonWidth = 56
        const buttonHeight = 24
        
        // The current hover state also affect the image offsets
        var bgPosX = "0px"
        var bgPosY = "0px"

        if (this.props.app.GetCore().GetTreeIsAlphabetical() == true) {
            bgPosX = "-56px"
        }

        if (this.state.hoverState == "hover") {
            bgPosY = "-24px"
        }

        if (this.state.hoverState == "pressed") {
            bgPosY = "-24px"
        }

        // Putting together the background image positions
        var bgPositionButton = bgPosX + " " + bgPosY

        // Rendering the resulting button
        return <div className="tooltip"
            style={{
                marginLeft: "5px", marginTop: "5px", backgroundImage: bgFile, backgroundPosition: bgPositionButton, height: "24px", width: "56px"
            }}
            onClick={this.onClick.bind(this)}
            onMouseOut={e => this.mouseOutHandler(e)}
            onMouseOver={e => this.mouseOverHandler(e)}
            onMouseDown={e => this.mouseDownHandler(e)}
            onMouseUp={e => this.mouseUpHandler(e)}>
            <span className="tooltiptext">{this.props.tooltipText}</span>
        </div>
    }
}



// WEBPACK FOOTER //
// ./client/view/NobbAlphaButton.tsx